import { StyleSheet, Text, View } from 'react-native';
import React, { FC } from 'react';
import TouchableElement from '@components/common/touchableElement';
import { scale } from '@components/frame';
import { isWeb } from '@helpers';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { ItemWrapperProps } from '@v2/pages/machines/common/types/props';
import { SimpleOnPress } from '@interfaces/base';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface WebDefaultStatusBlockProps extends Partial<SimpleOnPress>, Pick<ItemWrapperProps, 'C'> {
  allSelected?: boolean;
}

const WebDefaultStatusBlock: FC<WebDefaultStatusBlockProps> = ({ onPress, allSelected, C }) => {
  return (
    <View style={{ width: '100%', height: scale(41) }}>
      <TouchableElement testID={TEST_IDS.liveScreen.allMachinesButton} onPress={onPress}>
        {({ boxStyle, pressed, hovered, pressHoverColor }) => (
          <View style={{ paddingHorizontal: scale(12) }}>
            <View
              style={[
                boxStyle,
                {
                  borderColor: allSelected ? 'transparent' : C('Hairline/Light/Primary'),
                  borderTopWidth: StyleSheet.hairlineWidth,
                  borderBottomWidth: StyleSheet.hairlineWidth,
                  width: '100%',
                  height: scale(41),
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: C(
                    pressHoverColor(allSelected ? 'Selected/Light/List item' : isWeb ? 'Background/Light/System' : 'Background/Light/Field')
                  ),
                  borderRadius: scale(pressed || hovered || allSelected ? SCREEN_BORDER_RADIUS : 0),
                },
              ]}
            >
              <Text style={[font['Headline'], { color: C(allSelected ? 'Label/Light/AlwaysLight Primary' : 'Label/Light/Primary') }]}>
                {i18n.t('All Machines')}
              </Text>
            </View>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export { WebDefaultStatusBlock };
